import InstanceApi from "@/services/apiClient.js";
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters({ storeUrlPrefix: "getStoreUrlPrefix" }),
  },
  methods: {
    ...mapActions(["updateCurrentCartRecaps"]),

    async updateItemToCart(itemId, quantity) {
      try {
        let apiUrlAddOptionToCart = "mcp/cart/updateItemOptions/id/" + itemId + "/qty/" + quantity;
        const response = await InstanceApi.get(apiUrlAddOptionToCart);
        this.updateCurrentCartRecaps(response.data);
      } catch (error) {
        console.error(error);
      }
    },
  },

};
